import { useAppSelector } from '@/app/hooks'
import { ListMusicById } from '@/components/organisms/ListMusicById'
import { SelectAuth } from '@/features/spotifyAuth/authSlice'
import './playList.scss'

export const PlayList = () => {
    const { isGuest } = useAppSelector(SelectAuth)

    return (
        <main className='p-playlist'>
            <ListMusicById isGuest={isGuest} />
        </main>
    )
}
